import { BpmnModelJsonHelper, JsonConvertableImpl, TextValue } from '@edp-bif/common-api';

export class ProcessFilterConditionArgs extends JsonConvertableImpl {
    name: TextValue;
    upBillVoId: TextValue;
    downBillVoId: TextValue;
    isEnabled: TextValue;
    billProcessType: TextValue;
    sysInit: TextValue;
    bizType: TextValue;
    orderByCode: TextValue;
    orderByName: TextValue;
    OrderByLastModifiedTime: TextValue;
    pageSize: number;
    pageIndex: number;

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.name = null;
        this.upBillVoId = null;
        this.downBillVoId = null;
        this.isEnabled = null;
        this.billProcessType = null;
        this.sysInit = null;
        this.bizType = null;
        this.orderByCode = null;
        this.orderByName = null;
        this.OrderByLastModifiedTime = null;
        this.pageSize = 0;
        this.pageIndex = 0;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "name", this.name);
        BpmnModelJsonHelper.SetAttributeValue(obj, "upBillVoId", this.upBillVoId);
        BpmnModelJsonHelper.SetAttributeValue(obj, "downBillVoId", this.downBillVoId);
        BpmnModelJsonHelper.SetAttributeValue(obj, "isEnabled", this.isEnabled);
        BpmnModelJsonHelper.SetAttributeValue(obj, "billProcessType", this.billProcessType);
        BpmnModelJsonHelper.SetAttributeValue(obj, "sysInit", this.sysInit);
        BpmnModelJsonHelper.SetAttributeValue(obj, "bizType", this.bizType);
        BpmnModelJsonHelper.SetAttributeValue(obj, "orderByCode", this.orderByCode);
        BpmnModelJsonHelper.SetAttributeValue(obj, "orderByName", this.orderByName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "OrderByLastModifiedTime", this.OrderByLastModifiedTime);
        BpmnModelJsonHelper.SetAttributeValue(obj, "pageSize", this.pageSize);
        BpmnModelJsonHelper.SetAttributeValue(obj, "pageIndex", this.pageIndex);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.name = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "name", TextValue);
        this.upBillVoId = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "upBillVoId", TextValue);
        this.downBillVoId = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "downBillVoId", TextValue);
        this.isEnabled = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "isEnabled", TextValue);
        this.billProcessType = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "billProcessType", TextValue);
        this.sysInit = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "sysInit", TextValue);
        this.bizType = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "bizType", TextValue);
        this.orderByCode = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "orderByCode", TextValue);
        this.orderByName = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "orderByName", TextValue);
        this.OrderByLastModifiedTime = BpmnModelJsonHelper.GetAttributeValueAsJsonSerializable(obj, "OrderByLastModifiedTime", TextValue);
        this.pageSize = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "pageSize");
        this.pageIndex = BpmnModelJsonHelper.GetAttributeValueAsNumber(obj, "pageIndex");
    }
}
